export enum TruckAvailableStatus {
  Available = 'AVAILABLE',
  Assigned = 'ASSIGNED',
  NotAvailable = 'NOT_AVAILABLE'
}
